import { DueDate } from './types';

export const overdueOrIn7Days = (
  dueDate: DueDate,
): { className: string; dueSoon: boolean } => {
  const ONE_DAY = 24 * 60 * 60 * 1000;
  let className = '';
  const isOverdue =
    dueDate?.text?.toLowerCase().includes('overdue') ||
    (dueDate.date !== null &&
      (new Date(dueDate.date).getTime() - Date.now()) / ONE_DAY < 0);
  const isDueIn7Days = dueDate.date
    ? (new Date(dueDate.date).getTime() - Date.now()) / ONE_DAY <= 7 &&
      (new Date(dueDate.date).getTime() - Date.now()) / ONE_DAY > 0
    : false;
  const dueSoon = isOverdue || isDueIn7Days;

  if (isOverdue) {
    className = 'theme--icon-overdue';
  }

  if (isDueIn7Days) {
    className = 'theme--icon-warning';
  }

  return { className, dueSoon };
};

export const getDueDateString = (
  dueDate: DueDate,
  isFrameworkMatched: boolean,
): string => {
  const date =
    // eslint-disable-next-line no-nested-ternary
    dueDate.date === null
      ? isFrameworkMatched
        ? ''
        : '-'
      : new Date(dueDate.date).toLocaleDateString('en-US');

  return date;
};
